module.exports = __webpack_public_path__ + "4e2312748c590ac7ac2d6e6de9b331b5.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/relic-footer-logo2.png
// module id = 523
// module chunks = 0